var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { unpackComment, unpackComments } from "./comments.mapper";
import { UIModelComment, UIModelComments } from "./comments.model";
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { packQueryParams, stringifyQueryParams } from "../utils";
var commentURL = function (_a) {
    var channelId = _a.channelId, partnerId = _a.partnerId, commentId = _a.commentId;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId, "/comments/").concat(commentId);
};
var commentsURL = function (_a) {
    var channelId = _a.channelId, partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId, "/comments");
};
export var getComment = function (_a) {
    var channelId = _a.channelId, partnerId = _a.partnerId, commentId = _a.commentId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(commentURL({ partnerId: partnerId, channelId: channelId, commentId: commentId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelComment(unpackComment(data))];
            }
        });
    });
};
export var getComments = function (_a, queryParams) {
    var channelId = _a.channelId, partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(commentsURL({ partnerId: partnerId, channelId: channelId }), {
                        params: queryParams && packQueryParams(queryParams),
                        paramsSerializer: stringifyQueryParams,
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelComments(unpackComments(data))];
            }
        });
    });
};
export var addComment = function (_a, payload) {
    var channelId = _a.channelId, partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(commentsURL({ partnerId: partnerId, channelId: channelId }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelComment(unpackComment(data))];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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